import React from 'react';
import { Progress } from 'antd';
import { func, images, types } from 'utils';
import _ from 'lodash';
import moment from 'moment-timezone';


interface Props {
    item: types.Order;
}
const OrderTimer = ({ item }: Props) => {

    const show = [types.OrderStatus.PREPARING, types.OrderStatus.READY, types.OrderStatus.DELIVERY, types.OrderStatus.ARRIVED].includes(item.status);

    const [timeLeft, setTimeLeft] = React.useState(0);

    const updates = _.invert(item.statusHistory);
    let startTime = updates[types.OrderStatus.PREPARING];

    React.useEffect(() => {
        if (startTime) {
            // startTime = '2025-02-20 11:36:47';
            // 2025-02-20 09:10:29 09:40:29 09:25:31 ;
            const endTime = moment(startTime).add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
            const interval = setInterval(() => {
                const tl = func.secondsUntil(endTime);
                if (show && tl > 0) {
                    setTimeLeft(tl);
                    // console.log('OrderTimer', { tl, startTime, endTime, current: moment().format('YYYY-MM-DD HH:mm:ss') });
                } else {
                    setTimeLeft(0);
                    clearInterval(interval);
                }
            }, 1 * 1000);

            return () => clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime, timeLeft]);

    const percentage = (timeLeft / (60 * 30)) * 100;
    const isCompleted = item.status === types.OrderStatus.COMPLETED;

    return (
        <React.Fragment>
            {(show || isCompleted) && (
                <div id="OrderTimer" className={`d-flex ${isCompleted ? 'justify-content-center' : ''} ${item.status} align-items-center`}>
                    {isCompleted ? (
                        <img src={images.Delivered} alt="Delivered" height={30} />
                    ) : (
                        (
                            <Progress
                                type="circle"
                                steps={30}
                                percent={percentage}
                                trailColor="#B6101D"
                                strokeColor="rgba(0, 0, 0, 0.1)"
                                strokeWidth={20}
                                showInfo={false}
                            />
                        )
                    )}
                    <div className={`ml-2 text-xl`}>
                        {isCompleted ? 'Delivered' : (
                            <>
                                {timeLeft > 0 ? (
                                    <div>{timeLeft > 60 ? `${(timeLeft / 60).toFixed(2)} MIN` : `${timeLeft.toFixed(0)} SEC`}</div>
                                ) : (
                                    <div>BUSTED</div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default OrderTimer;